var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92308 2.84615C1.67826 2.84615 1.44347 2.94341 1.27036 3.11652C1.09725 3.28963 1 3.52442 1 3.76923V12.0769C1 12.3217 1.09725 12.5565 1.27036 12.7296C1.44347 12.9027 1.67826 13 1.92308 13H12.0769C12.3217 13 12.5565 12.9027 12.7296 12.7296C12.9027 12.5565 13 12.3217 13 12.0769V3.76923C13 3.52442 12.9027 3.28963 12.7296 3.11652C12.5565 2.94341 12.3217 2.84615 12.0769 2.84615H10.2308M3.76923 1V4.69231M10.2308 1V4.69231M3.76923 2.84615H8.38462M9.30769 7.92308H4.69231M7 5.61538V10.2308",
    stroke: "#6B7085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentCalendarIcon);
export default __webpack_public_path__ + "static/media/agent-calendar-icon.71298ea3b3565c32927264b5a808ed95.svg";
export { ForwardRef as ReactComponent };